import styled from "styled-components";

export const InputBar = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  border-radius: 1rem;
  background: #f2f2f2;
  padding: 0.5rem 1rem;
  margin: 0.5rem;
`;

export const Input = styled.input`
  border: none;
  background-color: transparent;
  outline: none;
`;

export const ContainerAddFile = styled.div`
  border-radius: 999rem;
  padding: 0.5rem;
  background: #f2f2f2;
  margin: 0.55rem;
  margin-left: 0rem;
  cursor: pointer;
  aspect-ratio: 1;
  position: relative;
  width: 40px;
  height: 40px;
`;

export const ContainerInput = styled.form`
  display: flex;
  width: 100%;
`;
